export default "__VITE_ASSET__CLcJExBC__"